/// <reference path="../../../../../rcwebmodels/TripDetails.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import forEach from 'lodash/forEach';
import { PopupWindow } from '../sharedcomponents/PopupWindow';

var Config: any = require('../../Config.json');

interface CreateTripSettingsState {
    SelectedReefers: any[];
    commandUnits: server.ReeferCommandUnits[];
    ClearDeviationTripParameters: server.ClearDeviationTripParameters;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}
var newClearDeviationTripParameters: server.ClearDeviationTripParameters = { TripId: 0, CommandUnits: [] };
export class TripDeviation extends React.Component<any, CreateTripSettingsState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        this.state = { SelectedReefers: [], commandUnits: [], ClearDeviationTripParameters: newClearDeviationTripParameters, IsCommandIssued: false, PrevSelectedItems: [] };

    }

    setForwardCommandUnits() {
        var userId = 0;
        var commandUnits = [];
        if (this.state.SelectedReefers.length > 0) {
            forEach(this.state.SelectedReefers, function (value, key) {
                var commandUnitObject = {
                    "RcdEventID": value.RCDEventID,
                    "RCDMasterID": value.RCDMasterID,
                    "RcdId": value.RCDID,
                    "ReeferID": value.ReeferID,
                    "UnitControlEventID": value.UnitControlEventID,
                    "UnitEventID": value.UnitEventID,
                    "UnitMasterID": value.UnitMasterID,
                    "ParentEventId": (value.ParentEventID.HasValue) ? value.ParentEventID.Value : 0,
                    "UserId": userId,
                    "TripId": value.TripId
                };

                commandUnits.push(commandUnitObject);
            });

            //this.setState({ commandUnits: commandUnits });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }
    componentDidMount() {
        var reeferData = this.props.reeferData;
        if (reeferData != undefined && reeferData != null) {
            this.setState({ SelectedReefers: reeferData });
        }
    }
    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var tripGeofencesDetails: server.ClearDeviationTripParameters = JSON.parse(JSON.stringify(this.state.ClearDeviationTripParameters));
            tripGeofencesDetails.TripId = reeferData[0].TripId;
            this.setState({ SelectedReefers: reeferData, ClearDeviationTripParameters: tripGeofencesDetails });
            // this.setForwardCommandUnits();
        }
    }

    closePopUp() {
       // document.getElementById("hidePopUpBtn").click();
        $("#hidePopUpBtn .close").click();
    }
    performYesAction() {
        var fCommends = this.setForwardCommandUnits();
        var tripGeofencesDetails: server.ClearDeviationTripParameters = JSON.parse(JSON.stringify(this.state.ClearDeviationTripParameters));
        tripGeofencesDetails.TripId = this.state.SelectedReefers[0].TripId;
        tripGeofencesDetails.CommandUnits = fCommends;
        this.setState({ ClearDeviationTripParameters: tripGeofencesDetails });
        //  setTimeout(() => {
        //this.setState({ ClearDeviationTripParameters: tripGeofencesDetails });
        //  }, 30);
        var edittripGeofencesDetails: server.EditTripGeofencesDetails = JSON.parse(JSON.stringify(this.state.ClearDeviationTripParameters));
        $('#contextMenuModel .close').click();
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/Trip/ClearDeviation';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(tripGeofencesDetails), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                this.setState({ ClearDeviationTripParameters: newClearDeviationTripParameters, IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                this.props.refreshStatusGrid();
                PopupWindow.showErrorMessage("Clear Trip Deviation", data);
            });
        this.closePopUp();
        //this.setState({ ClearDeviationTripParameters: newClearDeviationTripParameters });
        
        // this.props.refreshStatusGrid();
        //  $('#TripDeviation').hide();
    }

    public render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-info" role="alert">
                        <span className="glyphicon glyphicon-info-sign font-size-20 float-start" aria-hidden="true"></span>
                        <div className="alert-text">Are you sure you want to clear deviation </div>
                         
                    </div>            
 
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={this.performYesAction.bind(this)} >Yes</button>
                    <button type="button" id="hidePopUpBtn" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                    </div>

                </div>
            </div>
            
        );
    }
}